import parsePhoneNumber from 'libphonenumber-js';

export const toPhoneDigits = phone => {
  const parsed = parsePhoneNumber(phone || '');
  return parsed?.isValid() ? parsed.number.replace(/\D/g, '') : '';
};
